import React from 'react';
import classNames from 'classnames';
import {Button as SemanticButton, Image} from 'semantic-ui-react';

import constants from '@constants';
import {Props} from './types';

import './index.scss';

const SNS = (props: Props) => {
  const getText = (type: string) => {
    switch (type) {
      case 'google':
        return 'Googleで';
      case 'amazon':
        return 'Amazonで';
      case 'facebook':
        return 'Facebookで';
    }
  };

  const getIcon = (type: string) => {
    switch (type) {
      case 'google':
        return `${constants.IMAGES.GOOGLE}`;
      case 'amazon':
        return `${constants.IMAGES.AMAZON}`;
      case 'facebook':
        return `${constants.IMAGES.FACEBOOK}`;
    }
  };

  return (
    <div className="b__sns-button">
      <SemanticButton
        className={classNames(props.className)}
        onClick={props.onClick}
        loading={props.loading}
        disabled={props.disabled}
        fluid
      >
        <Image src={getIcon(props.type)} className="sns-icon" />
        <div className="b__button-text">{`${getText(props.type)}${
          props.signIn ? 'ログイン' : '新規登録'
        }`}</div>
      </SemanticButton>
    </div>
  );
};

export default SNS;
